
  import {
    Component,
    Vue
  } from "vue-property-decorator";
  import Step from '@/components/step.vue'
  import {
    orderSupportdetail,
    confirmReceiveGoods,
    orderSupporterrorReturnExpressNoAlert,
    orderSupportmodifyRealRefundMoney,
    orderSupportcheckReject,
    orderSupportcheckPass,
    orderSupportmodifyAlipayAccount,
    orderSupportmodifyReturnFreightInsuranceMoney,
    orderSupportmodifySystemRemark,
    orderSupportrefund,
  } from '@/api/after_sales'
  import {
		lookExpress
	} from '@/api/order'
  import collapseItem from '@/components/collapse.vue';
  import PageFooter from '@/components/page-footer.vue';
  import Message from '@/components/message.vue';
  import RefundChangeSku from '../order/components/refund-change-sku.vue';
  import previewImg from "@/components/previewImg.vue"
  import dialog from "@/components/dialog.vue"
	import fillinlogistics from './components/fillinlogistics.vue';
  import {
    afterStatus,
    afterSalesResults,
    afterSalesTypes
  } from '@/utils/config'
  import {
    getExpressList
  } from '@/api/logistics';
	import {
		handleClipboard
	} from '@/utils/clipboard'
  import changeRemark from "@/views/aftersales/components/changeRemark.vue"

  @Component({
    name: 'after-sales-detail',
    components: {
      Step,
      collapseItem,
      PageFooter,
      RefundChangeSku,
      'slz-message': Message,
      'slz-dialog':dialog,
      previewImg,
      fillinlogistics,
      changeRemark,
    }
  })
  export default class AfterSalesDetail extends Vue {
    private detailmsg:any = {}
    private stepList:any = []
    private showMessage = false
    private msgrul = ''
    private urlshow = false
    private fileType = 'image'

    private passshow = false
    private ejectedshow = false
    private ejectedmsg:any = {
      SupportNo:'',
      RejectReason:'',
      SystemRemark:'',
    } 
    private logisticsshow = false
    private logisticsmsg:any = []
    private logisticsdata:any = {}

    private takeGoodsShow = false
    private fillinShow = false

    private lookloading = false

    private smsShow = false

    private refundreasonlist = [
      {value:'拾物Zone原因-补贴'},
      {value:'供应商原因-补贴'},
    ]
    private RefundReasonForCustomerService = ''

    private changerefundShow = false
    private refundnum = ''

    private logisticsitem:any = {}
    private itemlist:any = []
    private detailloading = false

    private changeaccountShow = false
    private changeaccountmsg:any = {
      AlipayAccount:'',
      AlipayName:''
    }
    private changefreight = false
    private freightnum = ''

    
		private refundagainShow = false
		private refundagainloading = false
		private refundmsg: any = {
			title: '',
			content: '',
			Show: false,
			type: 'warn',
			showicon: true
		}
    private ReturnFreightInsuranceResponsibleParty = null
		private remarkShow = false
    private bannerColor = {
      0:'#f92519',
      1:'#ef8733',
      2:'#2e63f6',
      3:'#1cac34',
      4:'#873df1',
    }

    private mounted() {
      this.getdetail()
    }



    
		private copyAddress(event){
			let text = ''
			text += this.detailmsg.ReceiveName + '  ' + this.detailmsg.ReceivePhone + '\n'
			text += this.detailmsg.ReceiveProvince + this.detailmsg.ReceiveCity + this.detailmsg.ReceiveArea + this.detailmsg.ReceiveAddress
			handleClipboard(text, event)
		}
    private chooseNo(e) {
			// console.log(e)
			this.logisticsitem = e
			this.getlogistics(this.logisticsitem)
		}
    private async confirmrefundagain() {
			try {
				this.refundagainloading = true
				let data: any = {
					SupportNo: this.detailmsg.SupportNo,
					IsModifyRemark: true,
					noError: true
				}
				let res = await orderSupportrefund(data)
				if (res.IsSuccess) {
					this.refundagainShow = false
					this.refundmsg = {
						title: '退款成功',
						content: res.Message,
						Show: true,
						type: 'success',
						showicon: true
					}
					this.getdetail()
				} else {
					await this.getdetail()
					this.refundmsg = {
						title: '退款失败',
						content: res.Message,
						Show: true,
						type: 'warn',
						showicon: true,
						RefundState: this.detailmsg.RefundState,
						ReturnFreightInsuranceState: this.detailmsg.ReturnFreightInsuranceState,
					}
				}
			} catch (err) {
				this.refundagainShow = false
			} finally {
				this.refundagainShow = false
				this.refundagainloading = false
			}
		}
		private async saveremark() {
			try {
				let data = {
					SupportNo: this.detailmsg.SupportNo,
					SystemRemark: this.detailmsg.SystemRemark
				}
				let res = await orderSupportmodifySystemRemark(data)
				if (res.IsSuccess) {
					this.$message.success('操作成功')
					// this.$router.go(-1)
					this.getdetail()
				}
			} finally {
				//
			}
		}
    private async savefreight(type){
      if(type){
        try{
          let freightnum = Number(this.freightnum)
          let two = /^\d+(\.\d{1,2})?$/
          if(freightnum<0||!two.test(this.freightnum)){
            this.$message.error('请输入运费金额')
            return
          }else if(freightnum>100||!two.test(this.freightnum)){
            this.$message.error('运费金额不能超过100元')
            return
          }
          let res = await orderSupportmodifyReturnFreightInsuranceMoney({
            SupportNo:this.detailmsg.SupportNo,
            ReturnFreightInsuranceMoney:freightnum
          })
          if(res.IsSuccess){
            this.$message.success('操作成功')
            this.changefreight = false
            this.freightnum = ''
            this.getdetail()
          }
        }finally{
          //
        }
      }else{
        this.changefreight = false
        this.freightnum = ''
      }
    }
    private wantchangefreight(){
      this.changefreight = true
      this.freightnum = this.detailmsg.ReturnFreightInsuranceMoney
    }
    private async tochangeaccount(){
      try{
        let data = {
          SupportNo:this.detailmsg.SupportNo,
          ...this.changeaccountmsg
        }
        let res = await orderSupportmodifyAlipayAccount(data)
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.changeaccountShow = false
          this.getdetail()
        }
      }finally{
        //
      }
    }
    private accountoperation(type:boolean){
      if(type){
        if(!this.changeaccountmsg.AlipayAccount){
          this.$message.error('请输入退款收款账户')
          return
        }else if(!this.changeaccountmsg.AlipayName){
          this.$message.error('请输入收款姓名')
          return
        }
        this.tochangeaccount()
      }else{
        this.changeaccountShow = false
      }
    }
    private clickchangeaccount(){
      this.changeaccountShow = true
      this.changeaccountmsg = {
        AlipayAccount:this.detailmsg.AlipayAccount,
        AlipayName:this.detailmsg.AlipayName,
      }
    }
    private async handlepass(){
      if(this.detailmsg.SupportType==3&&this.detailmsg.SendState==1&&this.detailmsg.ProductState==0&&!this.RefundReasonForCustomerService){
        this.$message.error('请选择退款原因')
        return 
      }
      try{
        let res = await orderSupportcheckPass({
          SupportNo:this.$route.query.SupportNo,
          IsSystem:false,
          RefundReasonForCustomerService:this.RefundReasonForCustomerService,
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.$router.go(-1)
        }
      }finally{
        //  
      }
    }
    private clickpass(){
      this.passshow = true
    }
    private async confirmrejected(){
      // if(this.detailmsg.SupportType==3&&this.detailmsg.SendState==1&&this.detailmsg.ProductState==0&&!this.RefundReasonForCustomerService){
      //   this.$message.error('请选择退款原因')
      //   return 
      // }else 
      if(!this.ejectedmsg.RejectReason){
        this.$message.error('请填写拒绝理由')
        return 
      }
      try{
        let res = await orderSupportcheckReject({
          ...this.ejectedmsg,
          RefundReasonForCustomerService:this.RefundReasonForCustomerService,
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.$router.go(-1)
        }
      }finally{
        //
      }
    }

    private closerejected(){
      this.ejectedmsg = {
        SupportNo:'',
        RejectReason:'',
        SystemRemark:'',
      } 
      this.ejectedshow = false
    }
    private ejected(){
      this.ejectedmsg = {
        SupportNo:this.$route.query.SupportNo,
        RejectReason:'',
      }
      this.ejectedshow = true
    }
    
    private async appendChild(type:number){
      try{
        if(type==1){
          let two = /^\d+(\.\d{1,2})?$/
          if(!this.refundnum||!two.test(this.refundnum)){
            this.$message.error('请填写正确的退款金额')
            return
          }else if(Number(this.refundnum)>9999.99){
            this.$message.error('退款金额超限，请勿超过1万')
            return
          }
        }
        let data = {
          SupportNo:this.detailmsg.SupportNo,
          RealRefundMoney:this.refundnum,
        }
        let res = await orderSupportmodifyRealRefundMoney(data)
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.changerefundShow = false
          this.getdetail()
        }
      }finally{
        //
      }
    }
    private clickeditrefund(){
      this.refundnum = JSON.parse(JSON.stringify(this.detailmsg.RealRefundMoney))
    }

    private returntypefont(){
      let val = ''
      if(this.detailmsg.SupportType==1){
        val = '换货'
      }else if(this.detailmsg.SupportType==2){
        val = '退货'
      }else if(this.detailmsg.SupportType==3||this.detailmsg.SupportType==4){
        val = '退款'
      }
      return val
    }

    private async smsremind(){
      try{
        let res = await orderSupporterrorReturnExpressNoAlert({
          SupportNo:this.$route.query.SupportNo
        })
        if(res.IsSuccess){
          this.$message.success('已发送短信通知用户')
        }
      }finally{
        //
      }
    }
    private copyaftersales(event){
      let text = ''
      text += '★订单编号：' + this.detailmsg.OrderNoDisplay + '\n'
      text += '★售后编号：' + this.detailmsg.SupportNo + ';' + this.detailmsg.SupportTypeValue + '\n'
      text += '★申请人：' + this.detailmsg.CustomerName + '  ' + this.detailmsg.CustomerPhone + '\n'
      text += '★订单审核序列：' + this.detailmsg.CheckSequence + '\n'
      text += '★商品名称：' + this.detailmsg.ProductName + '\n'
      text += '★发货单号：' + this.detailmsg.OrderDetailExpressInfo
      // text += this.detailmsg.OriginaldetailmsgInfoList.map(v=>{
      //   v.ChildOrdermsg = v.ChildOrderEx + ' ' + v.ChildOrderNo
      //   return v
      // }).map(v=>v.ChildOrdermsg).join(',')
      text += '\n'
      // text += '★发货单号：' + this.detailmsg.ProductName + '\n'

      text += '★寄回单号：' + this.detailmsg.ReturnExpressValue + '' + this.detailmsg.ReturnExpressNo + '\n'
      text += '★下单时间：' + this.detailmsg.OrderAddTime + '\n'
      text += '★订单信息：' + this.detailmsg.ReceiveName + '。' + this.detailmsg.ReceivePhone + '。' + this.detailmsg.ReceiveProvince +
               this.detailmsg.ReceiveCity + this.detailmsg.ReceiveArea + this.detailmsg.ReceiveAddress + '。' + '\n' + 
               this.detailmsg.ProductName + '。'  + this.detailmsg.OriginalSpecValueDisplay + 'x' + this.detailmsg.ProductCount + '\n'
      text += '★售后原因：' + this.detailmsg.SupportReason + '\n'
      text += '★补充描述：' + this.detailmsg.CustomerRemark + '\n'
      if(this.detailmsg.SupportType==1){
        text += '★换后规格：' + this.detailmsg.ProductName + '。' + this.detailmsg.NewSpecValueDisplay + 'x' + this.detailmsg.ProductCount + '\n'
      }
      text += '★解决方案：'
      // console.log(text,event)      
      handleClipboard(text,event)
    }
    
    private async confirmtakeGoods(){
      if(this.detailmsg.SupportType==3&&this.detailmsg.SendState==1&&this.detailmsg.ProductState==0&&!this.RefundReasonForCustomerService){
        this.$message.error('请选择退款原因')
        return 
      }
      if((this.detailmsg.SupportType==1||this.detailmsg.SupportType==2)&&this.detailmsg.SupportState==30&&this.ReturnFreightInsuranceResponsibleParty==null
        &&this.detailmsg.ReturnFreightInsuranceMoney>0){
        this.$message.error('请选择本次售后的运费承担方！')
        return 
      }
      try{
        let res = await confirmReceiveGoods({
          SupportNo:this.detailmsg.SupportNo,
          RefundReasonForCustomerService:this.RefundReasonForCustomerService,
          ReturnFreightInsuranceResponsibleParty:this.ReturnFreightInsuranceResponsibleParty,
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.takeGoodsShow = false
          this.$router.go(-1)
        }
      }finally{
        //
      }
    }
    
    
    private tocopy(event){
      let text = this.detailmsg.ReceiveName + ' ' + this.detailmsg.ReceivePhone + '\n'
                 + this.detailmsg.ReceiveProvince + this.detailmsg.ReceiveCity + this.detailmsg.ReceiveArea + this.detailmsg.ReceiveAddress
      handleClipboard(text, event)
    }
    
		private async getlogistics(data){
			try{
        this.lookloading=true
        this.detailloading = true
        this.logisticsmsg = []
				let res = await lookExpress(await data)
				if(res.IsSuccess){
					this.logisticsmsg = res.Result.sort((a,b)=>{
            return -1
          }).map((item, index)=>{
						item.color = index===0 ? '#0067cc':'#999';
						return item;
					})
					// console.log(this.logisticsmsg)
				}
			}finally{
        this.lookloading=false
        this.detailloading = false
				//
			}
		}
    
    private looklogistics2(item,row){
      this.logisticsshow = true
      let data = {
        ...item,
        ReceivePhone:row.ReceivePhone
      }
      this.logisticsdata = {
        ExpressValue:this.detailmsg.ReturnExpressValue,
        ExpressNo:this.detailmsg.ReturnExpressNo,
        address:this.detailmsg.ReceiveProvince+this.detailmsg.ReceiveCity+this.detailmsg.ReceiveArea+this.detailmsg.ReceiveAddress
      }
      this.logisticsitem = data
      this.itemlist = row.OrderDetailExpressList.map(v=>{
        return {
          ExpressValue:v.ExpressValue,
          ExpressId:v.ExpressId,
          ExpressNo:v.ExpressNo,
          ReceivePhone:row.ReceivePhone
        }
      })
      this.getlogistics(data)
    }
    private looklogistics(e,type?:boolean){
      this.logisticsshow = type
      this.logisticsdata = {
        ExpressValue:e==1?this.detailmsg.ReturnExpressValue:this.detailmsg.NewExpressValue,
        ExpressNo:e==1?this.detailmsg.ReturnExpressNo:this.detailmsg.NewExpressNo,
        address:e==1?(this.detailmsg.ReturnReceiveProvince+this.detailmsg.ReturnReceiveCity+this.detailmsg.ReturnReceiveArea+this.detailmsg.ReturnReceiveAddress):
          (this.detailmsg.ReceiveProvince+this.detailmsg.ReceiveCity+this.detailmsg.ReceiveArea+this.detailmsg.ReceiveAddress)
      }
      let data = {
        ExpressId:e==1?this.detailmsg.ReturnExpressId:this.detailmsg.NewExpressId,
        ExpressNo:e==1?this.detailmsg.ReturnExpressNo:this.detailmsg.NewExpressNo,
        ReceivePhone:e==1?this.detailmsg.ReturnReceivePhone:this.detailmsg.ReceivePhone,
				ExpressValue:  e == 1 ?this.detailmsg.ReturnExpressValue: this.detailmsg.ExpressValue,
      }
      this.logisticsitem = data
      this.itemlist = [data]
      this.getlogistics(data)
    }





    private lookmsg(e,type){
      this.msgrul = e
      this.fileType = type
      this.urlshow = true
    }

    private handleConfirm(){

    }

    private async getdetail(){
      try{
        let res = await orderSupportdetail({
          SupportNo:this.$route.query.SupportNo
        })
        if(res.IsSuccess){
          let detailmsg = res.Result
          detailmsg.SupportNo = this.$route.query.SupportNo
          detailmsg.usermsg = detailmsg.CustomerName+(detailmsg.CustomerRoleGrade?'-'+detailmsg.CustomerRoleName:'')+' '+detailmsg.CustomerPhone
          detailmsg.proposer = detailmsg.CustomerName+(detailmsg.CustomerRoleGrade?'-'+detailmsg.CustomerRoleName:'')+' '+detailmsg.CustomerPhone
          this.detailmsg = detailmsg
          this.RefundReasonForCustomerService = detailmsg.RefundReasonForCustomerService
          this.clickeditrefund()
          this.stepList = this.detailmsg.OrderSupportRecordInfoList.map(v=>v.TitleDisplay)
        }
      }finally{
        //
      }
    }
    
    private copysuc(){
      this.$message.success('复制成功')
    }
    private copyerr(){
      this.$message.success('复制失败')
    }

  }
